import Button from '@components/atoms/button'
import { FastlyImage } from '@components/common/image'
import { WRAPPED_PDF_URL, wrappedYear } from '@pages/wrapped'

const WrappedDescription = () => {
  return (
    <div className="flex gap-4 container mx-auto px-5 md:px-10 items-center justify-between flex-col-reverse sm:flex-row py-10 md:py-16">
      <div className="gap-4 max-w-2xl flex flex-col sm:items-start">
        <h2 className="text-2xl lg:text-4xl font-600 leading-tight text-center sm:text-left">
          Your front-row seat to Codingal {wrappedYear} highlights.
        </h2>
        <p className="text-lg lg:text-2xl text-center sm:text-left">
          From first logins to final projects, {wrappedYear} was built through
          consistency and care.
          <br />
          From product upgrades to new course launches, this is the year we
          moved fast and stayed student-first.
        </p>
        <a href={WRAPPED_PDF_URL} target="_blank" rel="noopener noreferrer">
          <Button variant="outline" size="md" className="mt-8 w-full sm:w-auto">
            View Wrapped {wrappedYear}
          </Button>
        </a>
      </div>
      <div className="max-w-48 sm:max-w-none">
        <FastlyImage
          src="images/wrapped/penguin-winter.png"
          width={369}
          height={377}
          alt="Penguin Winter"
        />
      </div>
    </div>
  )
}

export default WrappedDescription
